import { GraphQLError, Source } from 'graphql'

export const getGraphQLError = (message: string, statusCode: string) =>
  new GraphQLError(message, {
    path: ['path'],
    positions: [1],
    source: new Source('body', 'name', { line: 1, column: 2 }),
    extensions: { code: statusCode },
  })
